module.exports = __webpack_public_path__ + "static/img/page61.76074ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page61.png
// module id = LU+T
// module chunks = 0